import { Injectable } from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {ProjectOptionToken, ProjectOptionTokenListItem, ProjectOptionTokensResponse} from '@catmodels/project-option-tokens/types';
import { Store } from '@ngrx/store';
import {Restangular} from 'ngx-restangular';
import {isNullOrUndefined} from 'util';
import * as componentActions from '../../../project-details/actions/tokens';

@Injectable()
export class ProjectOptionTokensService extends RestHttpService<any> {
  constructor(private service: Restangular,
              private store: Store<any>) {
    super('project-option-tokens', service);
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_TOKENS_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_TOKENS_DEACTIVATE});
  }

  /**
   * Extracts all option tokens from response and transform them to table list items.
   *
   * @param response
   */
  extractTokensFromResponse(response: ProjectOptionTokensResponse) {
    const res: ProjectOptionTokenListItem[] = [];
    // we need the embedded value as well as the link values
    if (!isNullOrUndefined(response) && !isNullOrUndefined(response._embedded) &&
      (response._embedded.item.length > 0)) {
      response._embedded.item.forEach((token: ProjectOptionToken, idx, arr) => {
        const tokenItem = {} as ProjectOptionTokenListItem;
        tokenItem.feature = token._links.feature.label;
        tokenItem.href = token._links.self.href;
        tokenItem.id = token.id;
        tokenItem.description = token.description;
        tokenItem.value = token.value;
        tokenItem.active = token.active;
        tokenItem.token = token;
        res.push(tokenItem);
      });
    }
    return res;
  }

  /**
   * (De)Activates a token within a project. Relation to project is given by the token
   *
   * @param token
   * @param active true/false
   */
  activateToken(token: ProjectOptionToken, active: boolean) {
    const data = {
      id: token.id,
      active: active
    };
    return this.update(data);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-option-tokens/services/project-option-tokens.service.ts